class BundleBuilder {
  constructor(containerSelector = '.sidebar__items') {
    this.container = document.querySelector(containerSelector);
    this.slotsWrapper = this.container.querySelector('.items_wrap');
    this.cardWrappers = document.querySelectorAll('.card-wrapper');
    this.productsInBundle = [];

    this.totalPrice = 0;
    this.priceDisplay = document.querySelector('.sidebar__price s');

    const bundleConfigEl = document.getElementById('bundle-config-data');
    this.bundleConfig = bundleConfigEl ? JSON.parse(bundleConfigEl.textContent) : null;
    this.KEY_CURRENT = 'yk_bundle_current_items';
    this.init();
    this.setBundlesPageVisited();
  }

  init() {
    this.initCards();

    this.addToCartButton = document.getElementById('bundle-add-to-cart');
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', () => this.addBundleToCart());
    }

    this.loadCurrentBundleFromSession();

    this.renderSlots();
    this.renderProgressBarSteps();

    this.updateTotalPrice();
    this.updateProgressBar();
    this.updateAddToCartButtonState();

    this.presetBundle();
    this.consumePendingBundleItems();

    window.addEventListener('scroll', this.stickyAddToCart);
    this.stickyAddToCart();
    this.stickyProductButtonsClickHandler();
  }

  saveCurrentBundleToSession() {
    try {
      localStorage.setItem(
        this.KEY_CURRENT,
        JSON.stringify({
          items: this.productsInBundle,
          ts: Date.now(),
        })
      );
    } catch (e) {
      console.log('Błąd przy zapisie sesji', e);
    }
  }

  setBundlesPageVisited() {
    try {
      localStorage.setItem(
        'yk_bundle_interacted',
        JSON.stringify({
          value: true,
          ts: Date.now(),
        })
      );
    } catch (e) {
      console.log('Błąd przy ustawianiu sesji', e);
    }
  }

  loadCurrentBundleFromSession() {
    try {
      const raw = localStorage.getItem(this.KEY_CURRENT);
      if (!raw) return;
      const { items = [] } = JSON.parse(raw) || {};
      if (!Array.isArray(items) || items.length === 0) return;
      this.productsInBundle = [...items, ...this.productsInBundle];
    } catch (e) {
      console.log('Błąd przy ładowaniu sesji', e);
    }
  }

  clearCurrentBundleFromSession() {
    try {
      localStorage.removeItem(this.KEY_CURRENT);
    } catch (e) {
      console.error('Błąd przy czyszczeniu sesji', e);
    }
  }

  consumePendingBundleItems() {
    const KEY_PENDING = 'yk_bundle_pending_items';

    try {
      const raw = localStorage.getItem(KEY_PENDING);
      if (!raw) return;

      const parsed = JSON.parse(raw) || {};
      const items = Array.isArray(parsed.items) ? parsed.items : [];

      if (items.length === 0) {
        localStorage.removeItem(KEY_PENDING);
        return;
      }

      if (typeof this.addItemPayloadToBundle === 'function') {
        items.forEach((p) => this.addItemPayloadToBundle(p));
      } else {
        items.forEach((p) => {
          if (!p || !p.variantId || !p.productId) return;
          this.productsInBundle.push({
            productId: p.productId,
            variantId: p.variantId,
            title: p.title || '',
            variantTitle: p.variantTitle || '',
            imageUrl: p.imageUrl || '',
            price: Number(p.price) || 0,
          });
        });
      }

      this.renderSlots();
      this.updateProgressBar();
      this.updateTotalPrice();
      this.saveCurrentBundleToSession();

      localStorage.removeItem(KEY_PENDING);
    } catch (e) {
      localStorage.removeItem('yk_bundle_pending_items');
    }
  }

  presetBundle() {
    const presetButton = document.querySelectorAll('.preset-bundle-button');

    presetButton.forEach((btn) => {
      btn.addEventListener('click', () => {
        const bundleId = btn.getAttribute('data-bundle-id');
        const presetData = document.querySelector(`[data-bundle-id="${bundleId}"].card-wrapper__preset-data`);
        const presetProducts = JSON.parse(presetData.textContent)?.variants || [];

        presetProducts.forEach((variant, index) => {
          this.productsInBundle.push({
            productId: variant.id,
            variantId: variant.id,
            title: variant.name.split(' - ')[0],
            variantTitle: variant?.public_title,
            imageUrl: variant?.featured_image?.src,
            price: variant.price / 100,
            bundleId,
          });
        });

        this.renderSlots();
        this.updateTotalPrice();
        this.updateProgressBar();
        this.updateAddToCartButtonState();
        this.saveCurrentBundleToSession();
      });
    });
  }

  initCards() {
    this.cardWrappers.forEach((card) => {
      const swatches = card.querySelectorAll('.swatch-item');
      const legend = card.querySelector('.color-swatch-legend .color-swatch-selected-value');

      swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => this.handleVariantSelect(card, swatch, swatches, legend));
      });

      const addBtn = card.querySelector('.add-to-bundle');
      if (addBtn) {
        addBtn.addEventListener('click', () => this.addToBundle(card));
      }
    });
  }

  handleVariantSelect(card, swatch, allSwatches, legend) {
    allSwatches.forEach((s) => s.classList.remove('active'));
    swatch.classList.add('active');

    const variantName = swatch.dataset.option;
    const variantId = swatch.dataset.variantId;
    const imageUrl = swatch.dataset.imageUrl;

    card.dataset.selectedVariantId = variantId;
    if (legend) legend.textContent = variantName;

    if (imageUrl) {
      const imgEl = card.querySelector('.card-media.img-primary');

      if (imgEl) {
        imgEl.src = imageUrl;

        imgEl.removeAttribute('srcset');
      }
    }
  }

  getCurrentDiscountPercentage() {
    if (!this.bundleConfig || !this.bundleConfig.discounts) return 0;

    const discounts = this.bundleConfig.discounts;

    const productCount = this.productsInBundle.length;

    const maxKey = Math.max(...Object.keys(discounts).map(Number));
    const appliedKey = Math.min(productCount, maxKey);

    return discounts[appliedKey] || 0;
  }

  updateAddToCartButtonState() {
    if (!this.addToCartButton) {
      this.addToCartButton = document.getElementById('bundle-add-to-cart');
    }
    const btn = this.addToCartButton;
    if (!btn) return;

    const shouldDisable = this.productsInBundle.length <= 1;

    btn.disabled = shouldDisable;

    if (shouldDisable) {
      btn.setAttribute('disabled', 'disabled');
      btn.classList.add('is-disabled');
    } else {
      btn.removeAttribute('disabled');
      btn.classList.remove('is-disabled');
    }
  }

  shouldShowPopup() {
    const XSELL_SUPPRESS_TTL_MS = 14 * 24 * 60 * 60 * 1000;
    try {
      const ts = Number(localStorage.getItem('yk_xsell_bundle_page') || 0);
      if (!ts) return false;
      return Date.now() - ts < XSELL_SUPPRESS_TTL_MS;
    } catch {
      return false;
    }
    //  return !!localStorage.getItem('yk_xsell_bundle_page');
  }

  addToBundle(card) {
    const btn = card.querySelector('.add-to-bundle');
    btn.innerHTML = 'Dodano';
    btn.style.color = '#000000';
    btn.style.backgroundColor = '#FFFFFF';
    const variantId = card.dataset.selectedVariantId;
    const productId = card.dataset.cardId;
    const title = card.querySelector('.card__heading')?.textContent?.trim();
    const variantTitle = card.querySelector('.color-swatch-selected-value')?.textContent?.trim();
    const image = card.querySelector('.card-media');
    const imageUrl = image?.getAttribute('src') || image?.getAttribute('data-src');

    const jsonScript = card.querySelector('.card-wrapper__data');
    let price = 0;

    if (jsonScript) {
      try {
        const json = JSON.parse(jsonScript.textContent);
        price = parseFloat((json.price || '0').replace(',', '.'));
      } catch (e) {
        console.error('Błąd parsowania JSON z .card-wrapper__data', e);
      }
    }

    setTimeout(() => {
      btn.innerText = 'Dodaj';
      btn.style.color = '#FFFFFF';
      btn.style.backgroundColor = '#000000';
    }, 2000);

    if (!variantId || !productId) return;

    const bundleData = { productId, variantId, title, variantTitle, imageUrl, price };
    this.productsInBundle.push(bundleData);
    this.saveCurrentBundleToSession();

    this.renderSlots();
    this.updateProgressBar();
    this.updateTotalPrice();
    this.updateAddToCartButtonState();
  }

  async addBundleToCart() {
    if (this.productsInBundle.length === 0) return;

    const bundleKey = this.container.dataset.bundleKey;

    const items = this.productsInBundle.map((product) => ({
      id: product.variantId,
      quantity: 1,
      properties: {
        _isBundle: bundleKey,
        _originalPrice: product.price,
        ...(!!product.bundleId && { _presetSystemId: product.bundleId }),
      },
    }));

    const popup = document.getElementById('cross-sell-popup-bundle');
    if (!this.shouldShowPopup() && popup) {
      document.body.style.overflow = 'hidden';
      popup.classList.remove('hidden');
    }

    this.trackBundleAddToCart(this.productsInBundle);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) throw new Error(`Błąd: ${response.status}`);

      this.clearCurrentBundleFromSession();
      localStorage.removeItem('yk_bundle_pending_items');
    } catch (err) {
      console.error('Błąd przy dodawaniu bundla do koszyka:', err);
    }
  }

  updateTotalPrice() {
    const count = this.productsInBundle.length;

    this.totalPrice = this.productsInBundle.reduce((sum, product) => {
      return sum + (product.price || 0);
    }, 0);

    const discountPercent = this.getCurrentDiscountPercentage();

    const priceWrapper = document.querySelector('.sidebar__price');

    const discountedPrice = Math.round(this.totalPrice * (1 - discountPercent / 100) * 100) / 100;

    const regularPriceEl = this.priceDisplay;
    const discountedPriceEl = document.querySelector('.sidebar__price span');

    if (count === 0) {
      if (priceWrapper) priceWrapper.style.display = 'none';
      if (regularPriceEl) regularPriceEl.textContent = '';
      if (discountedPriceEl) discountedPriceEl.textContent = '';
      return;
    }

    if (count === 1) {
      if (priceWrapper) priceWrapper.style.display = 'flex';
      if (regularPriceEl) regularPriceEl.textContent = '';
      if (discountedPriceEl) discountedPriceEl.textContent = discountedPrice.toFixed(2).replace('.', ',') + ' zł';
      return;
    }

    if (regularPriceEl) {
      regularPriceEl.textContent = this.totalPrice.toFixed(2).replace('.', ',') + ' zł';
    }
    if (discountedPriceEl) {
      discountedPriceEl.textContent = discountedPrice.toFixed(2).replace('.', ',') + ' zł';
    }

    if (priceWrapper) priceWrapper.style.display = 'flex';
  }

  trackProductRemove({ title }) {
    if (!title) return;
    dataLayerPromise({
      event: 'bundle_page_click',
      section: 'form',
      element: 'remove_from_bundle',
      element_value: title,
    });
  }

  trackBundleAddToCart(products) {
    dataLayerPromise({
      event: 'bundle_page_click',
      section: 'form',
      element: 'add_bundle_to_cart',
      element_value: products.length,
    });
  }

  removeFromSlot(index) {
    const removed = this.productsInBundle.splice(index, 1);
    removed.forEach((product) => this.trackProductRemove(product));

    this.saveCurrentBundleToSession();

    this.renderSlots();
    this.updateTotalPrice();
    this.updateProgressBar();
  }
  renderSlots() {
    this.slotsWrapper.innerHTML = '';
    this.slots = [];

    const productsCount = this.productsInBundle.length;
    const minVisibleSlots = 4;
    const baseSlots = Math.max(productsCount, minVisibleSlots);

    const totalSlots = productsCount >= baseSlots ? baseSlots + 1 : baseSlots;

    for (let i = 0; i < totalSlots; i++) {
      const slot = this.createSlot(i + 1);
      this.slots.push(slot);

      const relative = slot.querySelector('.relative');
      const placeholder = slot.querySelector('div:not(.relative)');
      const img = relative.querySelector('img');
      const label = relative.querySelector('span');
      const title = relative.querySelector('p');

      if (i < productsCount) {
        const product = this.productsInBundle[i];

        img.src = product.imageUrl;
        img.alt = product.title;
        label.textContent = product.variantTitle;
        title.textContent = product.title;

        relative.style.display = '';
        placeholder.style.display = 'none';

        const removeBtn = slot.querySelector('button[aria-label="remove item"]');
        removeBtn.addEventListener('click', () => this.removeFromSlot(i));
      }

      this.slotsWrapper.appendChild(slot);
    }
    this.updateAddToCartButtonState();
  }

  createSlot(index) {
    const slot = document.createElement('div');
    slot.className = 'w-[100px] flex-shrink-0';
    slot.innerHTML = `
      <div>
        <div class="text-gray100 bg-gray50 h-[124px] w-[100px] flex items-center justify-center rounded-md text-lg mb-1.5">
          ${index}
        </div>
        <span class="text-gray100 block py-1 text-sm">${index} produkt</span>
      </div>
      <div class="relative h-full flex flex-col" style="display: none;">
        <button aria-label="remove item" class="absolute top-1 right-1 text-white bg-black p-1 rounded-full">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-remove">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <img class="border border-black h-[124px] w-[100px] flex items-center justify-center rounded-md object-contain" alt="" role="presentation">
        <p class="py-1 font-medium text-xs"></p>
        <span class="py-1 text-gray100 font-normal text-xs"></span>
      </div>
    `;
    return slot;
  }

  renderProgressBarSteps() {
    const container = document.querySelector('.bundle-progress-container');
    if (!container) return;

    container.querySelectorAll('.step').forEach((step) => step.remove());

    const discounts = this.bundleConfig.discounts;

    const steps = Object.entries(discounts)
      .map(([count, discount]) => ({
        count: Number(count),
        discount: Number(discount),
      }))
      .sort((a, b) => a.count - b.count);

    // const stepPositions = {
    //   1: 1,
    //   2: 20.2,
    //   3: 39.4,
    //   4: 58.6,
    //   5: 77.8,
    //   6: 97,
    // };

    const stepPositions = {
      1: 1,
      2: 33,
      3: 66,
      4: 90,
    };

    const maxStep = Math.max(...steps.map((s) => s.count));

    steps.forEach((step) => {
      const left = stepPositions[step.count] ?? 0;

      const stepEl = document.createElement('div');
      stepEl.className = 'step';
      stepEl.style.left = `${left}%`;
      stepEl.dataset.products = step.count;
      stepEl.dataset.discount = step.discount;
      if (step.count === 1) {
        stepEl.textContent = `${step.discount}`;
      } else {
        stepEl.textContent = `${step.discount}%`;
      }

      container.appendChild(stepEl);
    });
  }

  updateProgressBar() {
    const progressBar = document.getElementById('bundles-progress-bar');
    const steps = document.querySelectorAll('.bundle-progress .step');
    if (!progressBar || !steps.length) return;

    let percent = 0;
    const maxProducts = 6;
    steps.forEach((step) => {
      const requiredProducts = parseInt(step.dataset.products, 10);
      const stepLeft = parseFloat(step.style.left);

      console.log('stepLeft', stepLeft);

      if (this.productsInBundle.length >= requiredProducts) {
        percent = stepLeft;
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });

    if (this.productsInBundle.length === 1) {
      percent = Math.max(percent, 7);
    }

    if (this.productsInBundle.length >= maxProducts) {
      percent = 100;
    }

    progressBar.style.width = `${percent}%`;
  }

  isElementInViewport = (el) => {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  stickyAddToCart = () => {
    const stickyBar = document.getElementById('sticky-add-bundle-to-cart');
    const addBtn = document.getElementById('bundle-add-to-cart');
    if (!stickyBar || !addBtn) return;

    stickyBar.onclick = () => {
      dataLayerPromise({
        event: 'bundle_page_click',
        section: 'form',
        element: 'scroll_to_summary',
      });
    };

    if (this.isElementInViewport(addBtn)) {
      stickyBar.classList.remove('active');
    } else {
      stickyBar.classList.add('active');
    }
  };

  stickyProductButtonsClickHandler = () => {
    const progressBar = document.querySelector('.bundle-progress');
    const stickyBar = document.getElementById('sticky-add-bundle-to-cart');

    if (stickyBar) {
      stickyBar.addEventListener('click', () => {
        progressBar.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'center',
        });
      });
    }
  };
}

//Analytics

const setUpBundlePageAnalytics = () => {
  const presetClicks = () => {
    const presetsBtn = document.querySelectorAll('.preset-bundle-button');

    presetsBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        const bundleName = btn.getAttribute('data-bundle-title');
        dataLayerPromise({
          event: 'bundle_page_click',
          section: 'preset',
          element: 'add_to_bundle',
          element_value: bundleName,
        });
      });
    });
  };

  const productClicks = () => {
    const productsBtn = document.querySelectorAll('.add-to-bundle:not(.preset-bundle-button)');
    productsBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        const productName = btn.parentNode.querySelector('.card__heading').innerText;
        dataLayerPromise({
          event: 'bundle_page_click',
          section: 'product',
          element: 'add_to_bundle',
          element_value: productName,
        });
      });
    });
  };

  const productSwatchClicks = () => {
    const swatchBtn = document.querySelectorAll('.swatch-item');
    swatchBtn.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const productName = swatch.parentNode.parentNode.querySelector('.card__heading').innerText;
        dataLayerPromise({
          event: 'bundle_page_click',
          section: 'product',
          element: 'change_variant_swatch',
          element_value: productName,
        });
      });
    });
  };

  const pageView = () => {
    const params = new URLSearchParams(window.location.search);
    const source = params.get('sr');
    dataLayerPromise({
      event: 'bundle_page_view',
      element: 'source',
      element_value: source ?? 'no-source',
    });
  };

  pageView();
  presetClicks();
  productClicks();
  productSwatchClicks();
};

document.addEventListener('DOMContentLoaded', setUpBundlePageAnalytics);
